import { registerComponents } from './methods';
export function TiniElementComponents(items) {
    return function (target) {
        return class extends target {
            connectedCallback() {
                registerComponents(items);
                super.connectedCallback();
            }
        };
    };
}
export function TiniElementTheming(theming) {
    return function (target) {
        var _a;
        return _a = class extends target {
            },
            _a.theming = theming,
            _a;
    };
}
//# sourceMappingURL=decorators.js.map